export default __webpack_public_path__ + "static/media/plans.bcf7c3df.jpg";